import { CustomIcon } from '../../../icons/types';

export const Car: CustomIcon = ({ className }) => (
  <svg
    className={className}
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="heroicons-outline/car">
      <path
        id="Vector"
        d="M28.666 10.6667L25.9993 13.3334L23.9993 8.40005C23.8107 7.89517 23.4736 7.45929 23.0323 7.14986C22.591 6.84043 22.0663 6.67198 21.5273 6.66672H11.866C11.3227 6.65424 10.7885 6.80807 10.335 7.10761C9.88157 7.40714 9.53044 7.83808 9.32868 8.34272L7.33268 13.3334L4.66602 10.6667"
        stroke="#38393A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M10 18.6666H10.0133"
        stroke="#38393A"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M23.332 18.6666H23.3454"
        stroke="#38393A"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4"
        d="M25.9993 13.3334H7.33268C5.85992 13.3334 4.66602 14.5273 4.66602 16V21.3334C4.66602 22.8061 5.85992 24 7.33268 24H25.9993C27.4721 24 28.666 22.8061 28.666 21.3334V16C28.666 14.5273 27.4721 13.3334 25.9993 13.3334Z"
        stroke="#38393A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_5"
        d="M7.33203 24.6666V26.6666"
        stroke="#38393A"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_6"
        d="M26 24.6666V26.6666"
        stroke="#38393A"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default Car;
